var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickveeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 314,
    height: 94,
    viewBox: "0 0 314 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 314,
    height: 94,
    transform: "translate(116.068 300.222)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_140",
    "data-name": "Mask Group 140",
    transform: "translate(-116.068 -300.222)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905",
    transform: "translate(127.879 314.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900",
    transform: "translate(64.931 4.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M794.845,464.064q-3.515,4.138-9.984,4.138-5.781,0-8.753-3.382t-2.972-9.787V432.01h7.98v22.923q0,6.766,5.616,6.766,5.813,0,7.849-4.171V432.01h7.98v35.535h-7.52Z",
    transform: "translate(-773.137 -417.1)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M866.786,402.634a4.235,4.235,0,0,1,1.166-3.054,4.4,4.4,0,0,1,3.333-1.216,4.46,4.46,0,0,1,3.35,1.216,4.2,4.2,0,0,1,1.183,3.054,4.108,4.108,0,0,1-1.183,3.005,4.493,4.493,0,0,1-3.35,1.2,4.436,4.436,0,0,1-3.333-1.2A4.137,4.137,0,0,1,866.786,402.634Zm8.473,44.763h-7.98V411.862h7.98Z",
    transform: "translate(-829.215 -396.952)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M921.927,460.85a7.215,7.215,0,0,0,4.959-1.741,5.946,5.946,0,0,0,2.1-4.3h7.521A11.719,11.719,0,0,1,934.44,461a13.57,13.57,0,0,1-5.255,4.549,15.654,15.654,0,0,1-7.159,1.675q-7.455,0-11.823-4.828t-4.368-13.333v-.821q0-8.111,4.335-12.989t11.823-4.877a14.6,14.6,0,0,1,10.329,3.695,13.235,13.235,0,0,1,4.187,9.7h-7.521a7.31,7.31,0,0,0-2.085-5.025,6.712,6.712,0,0,0-4.976-1.97,7.022,7.022,0,0,0-5.977,2.808q-2.1,2.807-2.135,8.522v1.281q0,5.781,2.085,8.621A7.016,7.016,0,0,0,921.927,460.85Z",
    transform: "translate(-852.599 -416.119)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M1008.883,430.051l-3.547,3.645v11.593h-7.981V394.844h7.981v29.1l2.5-3.12,9.819-11.067h9.59l-13.2,14.811,14.615,20.723h-9.229Z",
    transform: "translate(-907.402 -394.844)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M1092.329,457.43l7.521-25.419h8.243l-12.316,35.535h-6.929l-12.414-35.535h8.277Z",
    transform: "translate(-954.755 -417.1)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M1181.365,467.221q-7.587,0-12.3-4.778t-4.713-12.726v-.985a21.32,21.32,0,0,1,2.053-9.508,15.624,15.624,0,0,1,5.764-6.519,15.241,15.241,0,0,1,8.277-2.331q7.258,0,11.215,4.631t3.957,13.1v3.219H1172.4a10.666,10.666,0,0,0,2.939,6.963,8.824,8.824,0,0,0,6.486,2.562,10.806,10.806,0,0,0,8.933-4.433l4.3,4.1a14.357,14.357,0,0,1-5.7,4.943A17.841,17.841,0,0,1,1181.365,467.221Zm-.953-30.444a6.722,6.722,0,0,0-5.3,2.3,11.917,11.917,0,0,0-2.578,6.4h15.206v-.591a9.7,9.7,0,0,0-2.135-6.06A6.671,6.671,0,0,0,1180.413,436.777Z",
    transform: "translate(-1007.402 -416.119)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M1271.331,467.221q-7.586,0-12.3-4.778t-4.713-12.726v-.985a21.324,21.324,0,0,1,2.052-9.508,15.629,15.629,0,0,1,5.763-6.519,15.242,15.242,0,0,1,8.277-2.331q7.258,0,11.215,4.631t3.958,13.1v3.219h-23.219a10.668,10.668,0,0,0,2.94,6.963,8.822,8.822,0,0,0,6.486,2.562,10.807,10.807,0,0,0,8.934-4.433l4.3,4.1a14.364,14.364,0,0,1-5.7,4.943A17.845,17.845,0,0,1,1271.331,467.221Zm-.953-30.444a6.721,6.721,0,0,0-5.3,2.3,11.914,11.914,0,0,0-2.577,6.4H1277.7v-.591a9.7,9.7,0,0,0-2.135-6.06A6.671,6.671,0,0,0,1270.378,436.777Z",
    transform: "translate(-1061.276 -416.119)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903",
    transform: "translate(12.012 19.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M649.245,440.949a3.061,3.061,0,0,1-1.718-.527l-4.948-3.348A3.066,3.066,0,0,1,646.016,432l3.233,2.188,3.189-2.15a3.066,3.066,0,0,1,3.427,5.085l-4.907,3.307A3.061,3.061,0,0,1,649.245,440.949Z",
    transform: "translate(-641.231 -431.468)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902",
    transform: "translate(18.562 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M695.512,440.95a3.062,3.062,0,0,1-1.718-.527l-4.948-3.348A3.066,3.066,0,0,1,692.282,432l3.233,2.188,3.19-2.15a3.066,3.066,0,0,1,3.427,5.085l-4.907,3.307A3.063,3.063,0,0,1,695.512,440.95Z",
    transform: "translate(-687.498 -431.47)",
    fill: "#0a64f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M649.5,422.978l-5.007,5.006,5.106,5.106a22.237,22.237,0,1,1,8.577-6.76l-.518.672,5.023,5.023.674-.834a29.391,29.391,0,1,0-8.493,7.163l8.554,8.554,5.006-5.006Z",
    transform: "translate(-611.29 -383.527)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 7.08,
    height: 2.091,
    transform: "translate(53.346 64.599) rotate(-44.995)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 3.013,
    cy: 3.013,
    r: 3.013,
    transform: "translate(54.789 47.535)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(58.487 54.382)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 1.37,
    cy: 1.37,
    r: 1.37,
    transform: "translate(60.13 44.933)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickveeLogo);
export default __webpack_public_path__ + "static/media/quickveeLogo.4eb5bd2a7f9ed317484de14a3116ff98.svg";
export { ForwardRef as ReactComponent };